import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const PageHomeServices = () => {
  return (
    <>
        <Row className="w-100 justify-content-center container__HomeBienvenido d-md-none container__max__width">
            <Col className='col-11 col-lg-6 '>
                <div className="servicios__card naranja mt-0 mb-4">
                    <img className='image__cobertura' src="/assets/img/homeout/empleado_protegido.webp" width={295} height={208} alt="Independiente" />
                    <p className='mt-4'>Asalariado</p>
                    <div className="homeout__servicios-textos">
                        <p className='homeout__servicios-detalle empleado'>Desarrolla y potencializa nuevas habilidades para fortalecer tu perfil profesional.</p>
                        <NavLink to='/registro' className='homeout__servicios-btn mb-4 fontCIBFont'>Ver más</NavLink>
                    </div>
                </div>
            </Col>
            <Col className='col-11 col-lg-6 '>
                <div className="servicios__card celeste my-2">
                    <img className='image__cobertura' src="/assets/img/homeout/independiente_protegido.webp" width={295} height={208} alt="Independiente" />
                    <p className='mt-4'>Independiente</p>
                    <div className="homeout__servicios-textos">
                        <p className='homeout__servicios-detalle empleado'>Fortalece las herramientas necesarias para hacer crecer tu idea de negocio.</p>
                        <NavLink to='/registro' className='homeout__servicios-btn mb-4'>Ver más</NavLink>
                    </div>
                </div>
            </Col>
        </Row>
        <Row className="w-100 px-2 py-5 d-none d-md-flex container__max__width">
            <Col xs={12} md={6}> 
                <Card className='card__cobertura'>
                    <Row className='w-100 p-0 m-0'>
                        <Col className='col-12 p-0'>
                            <p className='titleCardHomeOut'>
                                Independiente
                            </p>
                        </Col>
                        <Col className='p-0 col-md-12 col-lg-6'>
                            <Row className='w-100 p-0 m-0'>
                                <Col className='col-12 p-0'>
                                    <p className='fontOpenSans mb-4'>
                                        Fortalece las herramientas necesarias para hacer crecer tu idea de negocio.
                                    </p>                                
                                </Col>
                                <Col className='col-12 p-0 text-center'>
                                    <NavLink to='/registro' className='homeout__servicios-btn mt-4'>Ver más</NavLink>                                
                                </Col>
                            </Row>
                        </Col>
                        <Col className='p-0 text-center col-md-12 col-lg-6'>
                            <img width={295} height={208} src="/assets/img/homeout/independiente_protegido.webp" className='image__cobertura mt-3' alt="Independiente" />
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col xs={12} md={6}> 
                <Card className='card__cobertura'>
                    <Row className='w-100 p-0 m-0'>
                        <Col className='col-12 p-0'>
                            <p className='titleCardHomeOut'>
                                Asalariado
                            </p>
                        </Col>
                        <Col className='p-0 col-md-12 col-lg-6'>
                            <Row className='w-100 p-0 m-0'>
                                <Col className='col-12 p-0'>
                                    <p className='fontOpenSans mb-4'>
                                        Desarrolla e impulsa nuevas habilidades para fortalecer tu perfil profesional.
                                    </p>                                    
                                </Col>
                                <Col className='col-12 p-0 text-center'>
                                    <NavLink to='/registro' className='homeout__servicios-btn mt-4'>Ver más</NavLink>
                                </Col>
                            </Row>
                        </Col>
                        <Col className='p-0 text-center col-md-12 col-lg-6'>
                            <img width={295} height={208} src="/assets/img/homeout/empleado_protegido.webp" className='image__cobertura mt-3' alt="Independiente" />
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </>
  )
}

export default PageHomeServices